const moduleLevel = [
    { idLevel: 1, module_level_name: "Fondamentaux" },
    { idLevel: 2, module_level_name: "Intermédiaire" },
    { idLevel: 3, module_level_name: "Avancée" },
    { idLevel: 4, module_level_name: "MasterClass" },
];

export default moduleLevel;
